import { render } from "./UserPlans.vue?vue&type=template&id=4bde3a43"
import script from "./UserPlans.vue?vue&type=script&lang=js"
export * from "./UserPlans.vue?vue&type=script&lang=js"

import "../../assets/style.css?vue&type=style&index=0&lang=css"

import exportComponent from "/builds/vidict/ott-platform/procricket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__